<template>
    <div>
        <page-title>寄存列表</page-title>
        <Form :model="queryParams" :label-width="135" inline>
            <FormItem label="租借人：" prop="leaseeId">
                <leasee-select roleType="LEASEE" v-model="queryParams.memberId" />
            </FormItem>
            <FormItem label="标的物小类：" prop="targetType">
                <target-type-select v-model="queryParams.targetType" />
            </FormItem>
            <Button type="primary" style="margin-left:20px" @click="search">查询</Button>
        </Form>
        <datagrid ref="lg" :columns="cols" :queryParams="queryParams" subListName :queryUrl="queryUrl" :pageSize="10" paramsName="param">
        </datagrid>
    </div>
</template>

<script>
import pageTitle from '_c/title/page-title'
import datagrid from '_c/datagrid';
import targetTypeSelect from '_c/select/targetTypeSelect'
import leaseeSelect from '@/components/select/payee-select.vue'
export default {
    components: { pageTitle, datagrid, targetTypeSelect,leaseeSelect},
    data() {
        return {
            targetList:[],//标的物小类
            queryParams: {
                memberId: "",
                storageId: "",
                targetType: "",
                targetCode: "",
                useType: "",
                qualityType: "",
            },
            queryUrl: "http://CORE-STORAGE/messageService/operateService/queryInventoryList",
            cols: [
                { title: '仓库名称', key: 'storageId', dict: ['bizObjects', 'warehouse', true] },
                { title: '标的物小类', key: 'targetType', dict: ['target', 'type', true] },
                { title: '寄存数量', key: "num" },
                { title: '创建时间', key: 'createTime', formatter: 'date' },
            ]
        }
    },
    mounted() {
        let memberId = window.sessionStorage.getItem('memberId')
        this.queryParams.memberId = memberId;
        this.getTargetList(memberId)
        
    },
    methods: {
        search() {
            this.$refs['lg'].loadFirstPage()
        },
        // 标的物小类数据
        async getTargetList(leaseeId) {
            this.targetList = [];
            let data = {
                url: "CORE-CONTRACT/messageService/billingModelService/queryTargetTypesByLeaseeId",
                body: {
                    leaseeId
                }
            }
            this.targetList = await this.invoke(data)
        },

    }

}
</script>